export default __webpack_public_path__ + "static/media/a037-student-t3-s3-8.1b1ad411.svg";